"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsperaDownloadModal = exports.EdgeAsperaPluginNotification = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-unused-vars, @typescript-eslint/no-var-requires */
var classnames_1 = __importDefault(require("classnames"));
var filesize_1 = __importDefault(require("filesize"));
var react_1 = __importDefault(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
require("./AsperaDownloadModal.scss");
var StackedIcons_1 = require("@app/components/controls/StackedIcons");
var Modal_1 = require("@app/components/layout/Modal");
var ModalContent_1 = require("@app/components/layout/ModalContent");
var AsperaPlugin_1 = require("@app/features/transfers/components/AsperaPlugin");
var constants_1 = require("@app/shared/constants");
var SupportEmailLink_1 = require("@app/components/SupportEmailLink");
var config_1 = require("@app/shared/config");
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var externalDownloadImage = require('@app/../static/External_1.png');
var externalMacDownloadImage = require('@app/../static/ExternalMac_2.png');
var externalWinDownloadImage = require('@app/../static/ExternalPC_2.png');
var internalMacDownloadImage = require('@app/../static/InternalMac_2.png');
// const internalMacInstallImage = require('@app/../static/InternalMac_3.png');
var internalWinDownloadImage = require('@app/../static/InternalPC_2.png');
// const internalWinInstallImage = require('@app/../static/InternalPC_3.png');
var safariExtensionImage = require('@app/../static/tooltip_safari.gif');
var isMac = navigator.platform.toLowerCase().includes('mac');
var isWindows = navigator.platform.toLocaleLowerCase().includes('win');
var isIE = (navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/g) || navigator.userAgent.match(/rv:11/g)));
var getDownloadUrl = function (isInternal) {
    if (isMac && isInternal) {
        return constants_1.INTERNAL_CONNECT_MAC_DOWNLOAD_URL;
    }
    else if (isWindows && isInternal) {
        return constants_1.INTERNAL_CONNECT_WINDOWS_DOWNLOAD_URL;
    }
    else {
        return constants_1.DEFAULT_CONNECT_DOWNLOAD_URL;
    }
};
var onExtDownloadClick = function (event) {
    new matomo_1.MatomoTracker().trackEvent('User', 'Clicked Aspera Extension Install Link');
};
var confirmDismissal = function () {
    return confirm("Are you sure?\n\nBlast Lite is limited to transfers of " + filesize_1.default(utils_1.megabytesToBytes(config_1.Config.HTTP_TRANSFER_MAX_PACKAGE_SIZE)) + " or less and will transfer more slowly");
};
var createStep = function (content, stepNum) {
    return (react_1.default.createElement("div", { className: "column" },
        react_1.default.createElement("div", { className: "box step" },
            react_1.default.createElement("span", { className: "tag is-info is-medium step-number" }, stepNum),
            react_1.default.createElement("div", { className: "has-text-centered" }, content))));
};
var createSteps = function (props) {
    var step1 = renderStep1(props.isInternal, props.asperaVersion);
    var step2 = renderStep2(props.isInternal);
    var step3 = renderStep3(props.isInternal, props.onContinue);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        createStep(step1, 1),
        step2 ? createStep(step2, 2) : null,
        createStep(step3, step2 ? 3 : 2)));
};
var renderFooter = function (props) {
    var continueButton = react_1.default.createElement("button", { type: "button", className: "button button-yellow", onClick: props.onClose }, (AsperaPlugin_1.isUnderRecommendedVersion(props.asperaVersion, constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION)) ?
        'Continue with older version' :
        'Continue');
    var skipButton = react_1.default.createElement("button", { type: "button", className: "button is-light", onClick: function () { if (confirmDismissal()) {
            props.onUseBlastLite();
        } } }, "Skip - Use Blast Lite");
    var modalButton = props.asperaStatus === 'RUNNING' ? continueButton : skipButton;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        modalButton,
        react_1.default.createElement("div", { className: "has-text-right", style: { width: '100%' } },
            react_1.default.createElement("p", null,
                "Need Help? ",
                react_1.default.createElement(SupportEmailLink_1.SupportEmailLink, null)))));
};
var renderStep1 = function (isInternal, version) {
    var onDownloadClick = function (event) {
        if (isWindows && isInternal && isIE) {
            event.preventDefault();
            // For Internal Windows users only, open the self service url in a new browser window
            window.open(getDownloadUrl(isInternal), 'popup', 'location,status,scrollbars,resizable,width=800, height=800');
        }
        new matomo_1.MatomoTracker().trackEvent('User', 'Clicked Aspera Install Link');
    };
    var onAltDownloadClick = function (event) {
        if (isWindows && isInternal && isIE) {
            event.preventDefault();
            // For Internal Windows users only, open the self service url in a new browser window
            window.open(getDownloadUrl(false), 'popup', 'location,status,scrollbars,resizable,width=800, height=800');
        }
        new matomo_1.MatomoTracker().trackEvent('User', 'Clicked Aspera Alternate Install Link');
    };
    if (react_device_detect_1.isSafari) {
        if (version !== '' && AsperaPlugin_1.isUnderRecommendedVersion(version, constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION)) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "Upgrade Aspera Connect"),
                react_1.default.createElement("p", { className: "italic" },
                    react_1.default.createElement("a", { href: getDownloadUrl(isInternal), onClick: onDownloadClick, target: "_blank", rel: "noopener noreferrer" }, "Primary Download Link")),
                isInternal &&
                    react_1.default.createElement("p", { className: "italic" },
                        react_1.default.createElement("a", { href: getDownloadUrl(false), onClick: onAltDownloadClick, target: "_blank", rel: "noopener noreferrer" }, "Alternate Download Link"))));
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "Enable Aspera's Browser Extension"),
                react_1.default.createElement("p", { className: "subheader" }, "Safari -> Preferences"),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("img", { src: safariExtensionImage.default })),
                react_1.default.createElement("p", { className: "note" },
                    "Don't see the Extension? - \u00A0",
                    react_1.default.createElement("a", { href: getDownloadUrl(isInternal), onClick: onDownloadClick, className: "note", target: "_blank", rel: "noopener noreferrer" }, "Primary Download Link")),
                isInternal &&
                    react_1.default.createElement("p", { className: "note" },
                        react_1.default.createElement("a", { href: getDownloadUrl(false), onClick: onAltDownloadClick, target: "_blank", rel: "noopener noreferrer" }, "Alternate Download Link"))));
        }
    }
    if (isInternal) {
        if (version !== '' && AsperaPlugin_1.isUnderRecommendedVersion(version, constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION)) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "Upgrade Aspera Connect"),
                react_1.default.createElement("p", { className: "italic" },
                    react_1.default.createElement("a", { href: getDownloadUrl(isInternal), onClick: onDownloadClick, target: "_blank", rel: "noopener noreferrer" }, "Primary Download Link")),
                react_1.default.createElement("p", { className: "italic" },
                    react_1.default.createElement("a", { href: getDownloadUrl(false), onClick: onAltDownloadClick, target: "_blank", rel: "noopener noreferrer" }, "Alternate Download Link"))));
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "Aspera Connect Install"),
                react_1.default.createElement("p", { className: "italic" },
                    react_1.default.createElement("a", { href: getDownloadUrl(isInternal), onClick: onDownloadClick, target: "_blank", rel: "noopener noreferrer" }, "Primary Download Link")),
                react_1.default.createElement("p", { className: "italic" },
                    react_1.default.createElement("a", { href: getDownloadUrl(false), onClick: onAltDownloadClick, target: "_blank", rel: "noopener noreferrer" }, "Alternate Download Link"))));
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null, (version !== '' && AsperaPlugin_1.isUnderRecommendedVersion(version, constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION)) ?
            'Click Here to Upgrade' :
            'Aspera Connect Install'),
        react_1.default.createElement("p", null,
            react_1.default.createElement("a", { href: getDownloadUrl(isInternal), onClick: onDownloadClick, target: "_blank", rel: "noopener noreferrer" },
                react_1.default.createElement("img", { src: externalDownloadImage.default })))));
};
var renderStep2 = function (isInternal) {
    if (react_device_detect_1.isSafari) {
        return null;
    }
    if (isInternal) {
        if (isMac) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "Click \"Open Self Service\""),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("img", { src: internalMacDownloadImage.default }))));
        }
        else if (isWindows) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "Click \"Open Sccclient\""),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("img", { src: internalWinDownloadImage.default }))));
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null, "Install Aspera Connect Client"),
        isMac && react_1.default.createElement("img", { src: externalMacDownloadImage.default }),
        isWindows && react_1.default.createElement("img", { src: externalWinDownloadImage.default })));
};
var renderStep3 = function (isInternal, onContinue) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null, "Once install is complete, click below"),
        react_1.default.createElement("p", { className: "continue" },
            react_1.default.createElement("a", { onClick: onContinue }, "Let's Go!"))));
};
var EdgeAsperaPluginNotification = function () {
    return (react_1.default.createElement("div", { id: "edge-notification" },
        react_1.default.createElement("i", { className: "fas fa-exclamation-triangle warning" }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", null, "Aspera extension may need to be enabled after installation."),
            react_1.default.createElement("p", null, "Open Edge's extensions to check: Menu -> Extensions")),
        react_1.default.createElement("i", { className: "fas fa-long-arrow-alt-up arrow" })));
};
exports.EdgeAsperaPluginNotification = EdgeAsperaPluginNotification;
var AsperaDownloadModal = function (props) {
    if (props.asperaStatus === 'RUNNING' && AsperaPlugin_1.isRecommendedVersionOrHigher(props.asperaVersion, constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION)) {
        setTimeout(function () { return props.onClose; }, 1000);
    }
    var onCloseModal = function () {
        if (props.asperaStatus === 'RUNNING' || confirmDismissal()) {
            if (props.onClose) {
                props.onClose();
            }
        }
    };
    var downloadHdr = react_1.default.createElement("h2", null,
        "Download/Install Application \u00A0",
        react_1.default.createElement("span", { className: "note" },
            "(minimum ",
            constants_1.ASPERA_PLUGIN_MIN_VERSION,
            ")"));
    var installedHdr = react_1.default.createElement("h2", null,
        "Aspera Connect version ",
        props.asperaVersion,
        " Installed",
        (AsperaPlugin_1.isUnderRecommendedVersion(props.asperaVersion, constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION)) ?
            react_1.default.createElement(react_1.default.Fragment, null,
                "\u00A0",
                react_1.default.createElement("span", { className: "note" },
                    "(recommended ",
                    constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION,
                    "+)")) : null);
    return (react_1.default.createElement(Modal_1.Modal, __assign({}, props, { closeOnEscape: true }),
        react_1.default.createElement(ModalContent_1.ModalContent, { title: "Aspera Connect Setup", onCloseClick: onCloseModal, className: "download-aspera-modal-content", renderFooter: function () { return renderFooter(props); } },
            (props.asperaVersion === '') ?
                react_1.default.createElement("p", { className: "info" },
                    "For best results with the ",
                    react_1.default.createElement("strong", null, "Blast"),
                    " file transfer service, please enable the ",
                    react_1.default.createElement("strong", null, "IBM Aspera Connect"),
                    " browser extension and application. You may skip this installation and continue with ",
                    react_1.default.createElement("strong", null, "Blast Lite"),
                    react_1.default.createElement("span", { className: "icon tooltip is-tooltip-bottom prewrap", "data-tooltip": "Blast Lite is only capable of transfers less than \n" + filesize_1.default(utils_1.megabytesToBytes(config_1.Config.HTTP_TRANSFER_MAX_PACKAGE_SIZE)) + " and will run at slower speeds" },
                        react_1.default.createElement("i", { className: "fas fa-info-circle" }))) : (AsperaPlugin_1.isUnderRecommendedVersion(props.asperaVersion, constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION)) ?
                react_1.default.createElement("p", { className: "info" }, "Keep Aspera Connect up to date to ensure you have the latest features and bug fixes.") : null,
            props.extInstallUrl &&
                react_1.default.createElement("div", { className: "modal-container" },
                    react_1.default.createElement("div", { className: classnames_1.default('columns', 'header', { 'is-active': !props.extInstallStatus }) },
                        react_1.default.createElement("div", { className: "column is-12" },
                            react_1.default.createElement(StackedIcons_1.StackedIcons, { className: "icon", innerIcon: "", outerIcon: props.extInstallStatus ? 'fas fa-check help is-success' : 'far fa-square is-active', tooltipMsg: "" }),
                            react_1.default.createElement("h2", { className: classnames_1.default({ 'extension-header': !props.extInstallStatus }) }, props.extInstallStatus ?
                                'Extension Installed' : 'Browser Extension'),
                            react_1.default.createElement("a", { href: props.extInstallUrl, onClick: onExtDownloadClick, target: "_blank", rel: "noopener noreferrer", className: classnames_1.default('button', 'button-yellow', { 'is-hidden': props.extInstallStatus }) }, "Click here to install Extension"))),
                    react_1.default.createElement("div", { className: classnames_1.default('columns', 'is-hidden') },
                        react_1.default.createElement("div", { className: classnames_1.default('column', 'is-3') }),
                        react_1.default.createElement("div", { className: classnames_1.default('column', 'is-3') },
                            react_1.default.createElement("a", { href: props.extInstallUrl, onClick: onExtDownloadClick, rel: "noopener noreferrer", target: "_blank", className: "button button-yellow is-fullwidth" }, "Install Browser Extension")),
                        react_1.default.createElement("div", { className: classnames_1.default('column', 'is-3') },
                            react_1.default.createElement("button", { type: "button", className: "button is-light is-fullwidth", onClick: props.onUseBlastLite }, "Skip - Use Blast Lite")),
                        react_1.default.createElement("div", { className: classnames_1.default('column', 'is-3') }))),
            react_1.default.createElement("div", { className: "modal-container" },
                react_1.default.createElement("div", { className: classnames_1.default('columns', 'header', { 'is-active': props.extInstallStatus }) },
                    react_1.default.createElement("div", { className: "column is-12" },
                        react_1.default.createElement(StackedIcons_1.StackedIcons, { className: "icon", innerIcon: "", outerIcon: (props.asperaStatus === 'RUNNING' ? 'fas fa-check help is-success' : (props.isInitializing ? 'fas fa-circle-notch fa-spin' : 'far fa-square')) + " " + (props.extInstallStatus ? 'is-active' : ''), tooltipMsg: "" }),
                        props.asperaStatus === 'RUNNING' ? installedHdr : downloadHdr)),
                react_1.default.createElement("div", { className: classnames_1.default('columns', { 'is-hidden': ((!props.extInstallStatus || props.asperaStatus === 'RUNNING') && (props.asperaVersion === '' || AsperaPlugin_1.isRecommendedVersionOrHigher(props.asperaVersion, constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION))) }) }, createSteps(props))))));
};
exports.AsperaDownloadModal = AsperaDownloadModal;
var mapStateToProps = function (store) {
    return {
        asperaStatus: store.transfers.connectStatus,
        asperaVersion: store.transfers.connectVersion,
        isInternal: store.auth.userInfo ? store.auth.userInfo.isInternal : false
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(exports.AsperaDownloadModal);
